import React from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TableRow, TableCell, TableBody, Table, TableContainer, TableHead, Paper, Chip
} from "@mui/material";

export function NewRequisicaoFourthStep ({ colaborador, produtosSelecionados, tipoRequisicao, selectedJustificativa, marcarComoEntregue }) {
    return (
        <Card variant="outlined" sx={{ mt: 3, borderColor: 'primary.main', boxShadow: 3 }}>
            <CardContent>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography variant="h5" color="primary" gutterBottom>
                        Confirmação de {tipoRequisicao === 'retirada' ? 'Retirada' : 'Requisição Extra'}
                    </Typography>

                    <Chip
                        label={tipoRequisicao === 'retirada' ? 'Retirada' : 'Requisição Extra'}
                        color={tipoRequisicao === 'retirada' ? 'primary' : 'secondary'}
                        sx={{ mb: 2 }}
                    />
                </Box>

                {/* Dados do colaborador */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        Colaborador
                    </Typography>
                    <Typography>
                        {colaborador?.nome} — Matrícula: <strong>{colaborador?.matricula}</strong>
                    </Typography>
                </Box>

                {/* Produtos selecionados em tabela */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                        Produtos Selecionados
                    </Typography>
                    <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
                                    <TableCell>Produto</TableCell>
                                    <TableCell>Variação</TableCell>
                                    <TableCell>Quantidade</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {produtosSelecionados.map((item, index) => {
                                    const variacao =
                                        item.produto.filhos?.find((f) => f.id === item.variacaoSelecionada)?.nome ||
                                        (item.variacaoSelecionada ? `ID ${item.variacaoSelecionada}` : '-');

                                    return (
                                        <TableRow key={item.id_unico || index} sx={{ backgroundColor: index % 2 === 0 ? '#fafafa' : 'white' }}>
                                            <TableCell>{item.produto.nome}</TableCell>
                                            <TableCell>{item.variacaoSelecionada ? variacao : '—'}</TableCell>
                                            <TableCell>{item.quantidadeSelecionada}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </CardContent>
        </Card>
    );
};
